import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { getTeamLogo } from "../../../utils/SportsData";
import '../superPickemStyles/UserPick.scss';
import { DateTime } from 'luxon';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { all } from "axios";

const MyPickSingleGameDisplay = ({
    pick,
    schedule,
    teams,
    league,
    todaysInterval,
    interval,
    allGamesInPast,
}) => {
    //console.log("Today's Interval:", todaysInterval, "Interval:", interval);

    function isIntervalInFuture(todayInterval, interval) {
        // If interval starts after today's interval ends, it's in the future
        return interval?.start >= todayInterval?.end;
      }

    const isFutureDate = useMemo(() => {
        return isIntervalInFuture(todaysInterval, interval);
      }, [todaysInterval, interval]);
      
      //console.log("Is Future Date:", isFutureDate);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const pickId = pick?.gameId;
    const userResult = pick?.result || 'pending';
    //console.log("Pick ID:", pickId);
    const selectedGame = schedule?.find((game) => game.GlobalGameID === pickId);
    //console.log("Selected Game:", selectedGame);

    const awayTeam = selectedGame?.AwayTeam;
    const homeTeam = selectedGame?.HomeTeam;
    //console.log("Away Team:", awayTeam, "Home Team:", homeTeam);

    const awayLogo = getTeamLogo(league, selectedGame?.GlobalAwayTeamID, teams);
    const homeLogo = getTeamLogo(league, selectedGame?.GlobalHomeTeamID, teams);
    //console.log("Away Logo:", awayLogo, "Home Logo:", homeLogo);

    const status = selectedGame?.Status;
    const gameDateTime = selectedGame?.DateTime;
    //console.log("Game Date Time:", gameDateTime);

    function getETTimeOnly(dateTimeStr) {
        return DateTime.fromISO(dateTimeStr, { zone: 'America/New_York' })
          .toFormat('h:mm a');
      }

    const formattedTime = getETTimeOnly(gameDateTime);
    //console.log("Formatted Time:", formattedTime);

    const awayScore = selectedGame?.AwayTeamScore ?? selectedGame?.AwayScore;
    const homeScore = selectedGame?.HomeTeamScore ?? selectedGame?.HomeScore;

    const selectedTeamId = pick?.teamId;
    const isTeamHome = selectedGame?.GlobalHomeTeamID === selectedTeamId;
    //console.log("Selected Team ID:", selectedTeamId, "Is Team Home:", isTeamHome);
    const selectedSpread = pick?.spread;
    const spreadForDisplay = selectedSpread === 0 ? 'Pk' : selectedSpread > 0 ? `+${selectedSpread}` : selectedSpread;

    const spreadDisplay = isTeamHome ? 
        `${homeTeam} (${spreadForDisplay})` :
        `${awayTeam} (${spreadForDisplay})`;
    //console.log("Spread Display:", spreadDisplay);

    const bottomText = selectedGame?.IsClosed ? status : status === 'InProgress' ? 'Live' : formattedTime ;

    if (!selectedGame) {
        return (
            <Box sx={{ width: '100%', margin: '0 auto', justifyContent: 'center' }}>
                <Box
                    className="teams-stat-bar-game-pending"
                    sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    padding: '16px 0px',
                    color: '#CC293C',
                    width: '325px',
                    height: '130px',
                    margin: '0 auto',
                    borderRadius: '4px',
                    }}
                >
                    <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: isMobile ? '10px' : '30px',
                        margin: '0 auto',
                    }}
                    >
                    <Typography
                        className="game-state"
                        sx={{
                        fontSize: isMobile ? '20px' : '32px',
                        fontWeight: 700,
                        color: (isFutureDate || !allGamesInPast) ? '#002129' : '#CC293C',
                        lineHeight: isMobile ? 1 : 0.5,
                        whiteSpace: 'nowrap',
                        }}
                    >
                       {(isFutureDate || !allGamesInPast) ? 'Pick TBD' : 'No Pick'}
                    </Typography>
                    {(!isFutureDate && allGamesInPast) && (
                        <CloseIcon
                            className="close-icon"
                            sx={{
                            color: '#CC293C',
                            fontSize: isMobile ? '32px' : '48px',
                            position: 'relative',
                            top: '3px',
                            }}
                        />
                    )}
                    </Box>
                </Box>
                </Box>

        );
    }


    return (
        <Box className="teams-stat-bar-game-pending">
            <Box className="team-lines">
                <Typography className="spreads">{!isTeamHome ? spreadDisplay : null}</Typography>
                <Typography className="spreads">{isTeamHome ? spreadDisplay : null}</Typography>
            </Box>
            <Box className="layout">
                <Box className="visuals">
                <img
                    className={!isTeamHome ? `team-logo-${userResult}` : 'team-logo'}
                    loading="lazy"
                    alt=""
                    src={awayLogo}
                />
                <Box className="caption-wrapper">
                    <h1 className="caption">@</h1>
                    <Typography className="game-state">{bottomText}</Typography>
                </Box>
                <img
                    className={isTeamHome ? `team-logo-${userResult}` : 'team-logo'}
                    loading="lazy"
                    alt=""
                    src={homeLogo}
                />
                </Box>
            </Box>
            <Box className="bottom-container">
            <Typography className="score">{awayScore}</Typography>
            <Typography className="score">{homeScore}</Typography>
        </Box>

    </Box>
    );
};

export default MyPickSingleGameDisplay;